import styled from "styled-components";

export const Container = styled.main`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media screen and (max-width: 1200px) {
    display: flex;
    flex-direction: column;
    padding: 0 2rem;
  }
`;

export const AboutInciativas = styled.section`
  max-width: 1026px;
  width: 100%;
  margin-top: 1rem;

  h2 {
    padding-top: 1.5rem;
  }

  p {
    padding-top: 1rem;
    font-weight: 200;
  }
  padding-bottom: 4rem;
`;

export const CarouselContainer = styled.section`
  width: 95%;
  max-width: 1376px;

  height: auto;
  margin-bottom: 3rem;
  padding: 3rem 7.5rem;
  border-radius: 24px;
  background-color: ${({ theme }) => theme.colors.variation};

  @media screen and (max-width: 1200px) {
    padding: 2rem 0;
    width: 100%;
    max-width: 100%;
  }
`;

export const SlideContent = styled.div`
  width: 100%;
  display: flex !important;
  justify-content: space-between;
  padding: 1rem 2rem;
  flex-wrap: wrap;

  @media screen and (max-width: 1200px) {
    display: flex !important;
    flex-direction: column !important;
    padding: 1rem 1rem;
    gap: 4rem;
    align-items: center;
  }
`;

export const FirstSection = styled.div`
  width: 50%;
  max-width: 500px;
  margin-right: 2rem;

  @media screen and (max-width: 1200px) {
    width: 100%;
    max-width: 100%;
  }
  ul {
    padding-top: 1rem;
    margin-left: 0.5rem;

    h2 {
      padding-bottom: 1rem;
    }

    li {
      margin-left: 0.5rem;
      margin-top: 0.5rem;
    }
  }

  p {
    padding-top: 1.375rem;
    font-weight: 200;
    text-align: justify;
    padding-right: 1.5rem;
  }
`;

export const SecondSection = styled.div`
  width: 45%;
  max-width: 500px;
  display: flex;
  justify-content: flex-end;

  @media screen and (max-width: 1200px) {
    width: 100%;
    max-width: 100%;
    padding: 0 2rem;
    margin-right: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  img {
    width: 100%;
    height: auto;
  }
`;
